export let FailureCodeOld = /*#__PURE__*/function (FailureCodeOld) {
  FailureCodeOld["ArchivedData"] = "archivedData";
  FailureCodeOld["Unknown"] = "unknown";
  return FailureCodeOld;
}({});
export let FailureCode = /*#__PURE__*/function (FailureCode) {
  FailureCode["Unknown"] = "unknown";
  FailureCode["DuplicateDocumentNumberError"] = "duplicate_document_number_error";
  FailureCode["AmountCalculationIncorrect"] = "amount_calculation_incorrect";
  FailureCode["CustomerDeleted"] = "customer_deleted";
  FailureCode["ItemDeleted"] = "item_deleted";
  FailureCode["ClassDeleted"] = "class_deleted";
  FailureCode["InvoiceAmountNotMatching"] = "invoice_amount_not_matching";
  FailureCode["ObjectNotFound"] = "object_not_found";
  FailureCode["AccountDeleted"] = "account_deleted";
  FailureCode["VendorDeleted"] = "vendor_deleted";
  FailureCode["InvoicePaid"] = "invoice_paid";
  FailureCode["DepositTotalAmountNotMatching"] = "deposit_total_amount_not_matching";
  FailureCode["TransactionCannotBeAppliedToDeposit"] = "transaction_cannot_be_applied_to_deposit";
  FailureCode["InvoiceDeleted"] = "invoice_deleted";
  FailureCode["PaymentDeleted"] = "payment_deleted";
  FailureCode["AccountPeriodClosed"] = "account_period_closed";
  FailureCode["InvalidCompanyStatus"] = "invalid_company_status";
  FailureCode["MissingPermissions"] = "missing_permissions";
  return FailureCode;
}({});